import type AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import type AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import type OneDriveConsumerScope from 'owa-service/lib/contract/OneDriveConsumerScope';
import type OneDriveProScope from 'owa-service/lib/contract/OneDriveProScope';
import {
    OneDriveConsumerScopeName,
    OneDriveItemsSkipTokenPagingMetadataType,
    OneDriveProScopeName,
} from '../constants';
import type { OneDriveItemsSkipTokenPagingMetadata } from '../types/OneDriveItemsSkipTokenPagingMetadata';

export function isOneDriveProScope(
    scope: AttachmentDataProviderScope | null
): scope is OneDriveProScope {
    return scope !== null && scope.__type === OneDriveProScopeName;
}

export function isOneDriveConsumerScope(
    scope: AttachmentDataProviderScope | null
): scope is OneDriveConsumerScope {
    return scope !== null && scope.__type === OneDriveConsumerScopeName;
}

export function isOneDriveItemsSkipTokenPagingMetadata(
    pagingMetadata: AttachmentItemsPagingMetadata
): pagingMetadata is OneDriveItemsSkipTokenPagingMetadata {
    return pagingMetadata && pagingMetadata.__type === OneDriveItemsSkipTokenPagingMetadataType;
}
